import React, { useEffect } from 'react';
import './Checkout.scss';
import { Steps, Tooltip } from 'antd';

import CheckoutAddress from '../CheckoutAddress/CheckoutAddress';
import CheckoutPayment from '../CheckoutPayment/CheckoutPayment';

import locationStepIcon from '../../assets/img/icon/location-step.svg';
import locationAcStepIcon from '../../assets/img/icon/location-step-active.svg';
import loginStepIcon from '../../assets/img/icon/login-step.svg';
import loginAcStepIcon from '../../assets/img/icon/login-step-active.svg';
import paymentStepIcon from '../../assets/img/icon/payment-step.svg';
import paymentAcStepIcon from '../../assets/img/icon/payment-step-active.svg';
import { useDispatch, useSelector } from 'react-redux';
import checkoutStepAction from '../../actions/checkout-step.action';

const steps = [
    {
        title: 'SIGN IN',
        content() {
            return <div>First-content</div>;
        },
        icon: loginStepIcon,
        iconAc: loginAcStepIcon,
    },
    {
        title: 'ADDRESS',
        content() {
            return <CheckoutAddress />;
        },
        icon: locationStepIcon,
        iconAc: locationAcStepIcon,
    },
    {
        title: 'PAYMENT & CHECKOUT',
        content() {
            return <CheckoutPayment />;
        },
        icon: paymentStepIcon,
        iconAc: paymentAcStepIcon,
    },
];

const Checkout = () => {
    const current = useSelector(state => state.checkoutStep.step);
    const dispatch = useDispatch();

    const onChange = (current) => {
        switch (current) {
            case 1:
                dispatch(checkoutStepAction.addressStep());
                break;
            case 2:
                dispatch(checkoutStepAction.paymentStep());
                break;
        }
    };

    useEffect(() => {
        onChange(1);
    }, []);

    return (
        <div className="checkout pt-170px">
            <Steps current={current} onChange={onChange}>
                {steps.map((item, index) => (
                    <Steps.Step
                        key={item.title}
                        icon={
                            <div className="position-relative">
                                {/*<div className="size-12 text-uppercase title position-absolute w-100 d-flex justify-content-center">*/}
                                {/*    <div className="position-static">{item.title}</div>*/}
                                {/*</div>*/}
                                <Tooltip placement="top" title={item.title}>
                                    <img src={index <= current ? item.iconAc : item.icon} alt="" />
                                </Tooltip>
                            </div>
                        }
                    />
                ))}
            </Steps>
            <div className="steps-content pt-60px">{steps[current].content()}</div>
        </div>
    );
};

export default Checkout;
